const CONSENT_MARKER = '__practium_consent_required';

export function createConsentError(token: string): Error {
	const err = new Error('CONSENT_REQUIRED') as any;
	err[CONSENT_MARKER] = true;
	err.consentToken = token;
	return err;
}

export function isConsentRequired(err: unknown): err is Error & { consentToken: string } {
	return (
		err !== null &&
		typeof err === 'object' &&
		(err as any)[CONSENT_MARKER] === true &&
		typeof (err as any).consentToken === 'string'
	);
}
